import PropTypes from 'prop-types';
import PO from '@src/assets/icons/ticketcar/4.svg';
import TOTAL from '@src/assets/icons/ticketcar/41.svg';
import BP from '@src/assets/icons/ticketcar/42.svg';

const CustomIconComponent = ({ providerType }) => {
  switch (providerType) {
    case 4:
      return PO;
    case 41:
      return TOTAL;
    case 42:
      return BP;
    default:
      return null;
  }
};

CustomIconComponent.propTypes = {
  providerType: PropTypes.number,
};

export default CustomIconComponent;
